// api.js

import axios from "axios";
const apiDomain = process.env.REACT_APP_API_URL;

const api = {
  url: apiDomain,
  cookieDomain: apiDomain.replace(/https?:\/\/(api||app)?/,"").replace(/:\d+$/,""),  // `.vetmanaged.com` or `.vetmanaged.loc`.  // prefix `.` shares cookie between root & subdomains ('app.' or 'api.' is removed).

  login:                    "/auth",          // POST
  logout:                   "/auth/logout",   // POST
  session:                  "/api/users/me",  // GET
  changeLocation:           "/api/users/location/{location_id}",  // POST

  getAppointentTypes:       "/api/appointment_types/all",     // GET
  getSchedules:             "/api/schedules",                 // GET
  getScheduleConfig:        "/api/schedules/{schedule_id}",   // GET
  getScheduleDateAppts:     "/api/schedules/{schedule_id}/group/{group_id}/resource/{resource_id}/date/{schedule_date}",  // GET

  getClientDetails:         "/api/clients/{client_id}/details",                   // GET
  getClientInvoices:        "/api/invoices/list/{client_id}",                     // GET
  getClientInvoice:         "/api/invoices/{invoice_id}",                         // GET
  getPatientDetails:        "/api/patients/{patient_id}/details",                 // GET
  getPatientVaccinations:   "/api/patient_vaccinations/patient_id/{patient_id}",  // GET
  getPatientServices:       "/api/patients/{patient_id}/services/5",              // GET
  getPatientPrescriptions:  "/api/patients/{patient_id}/prescriptions",           // GET
  getPatientReminders:      "/api/reminders/patient/{patient_id}",                // GET
  getPatientVisits:         "/api/patients/{patient_id}/visits",                  // GET
  getVisitDetails:          "/api/visits/{visit_id}",                             // GET
  getVisitAssessments:      "/api/visits/{visit_id}/assessments",                 // GET
  appointmentCheck:         "/api/appointments/status/{appointment_id}/checkin",  // POST
  getAssessmentDetails:     "/api/assessments/{assessment_id}",                   // GET
  getBillingDetails:        "/api/invoices/list/{client_id}",                     // GET

};


const axiosConfig = {
  baseURL: apiDomain,
  timeout: 5000,
  headers: {
    "Accept": "application/json",
    "Content-Type": "application/x-www-form-urlencoded",   // for POST only. This is ignored in GET requests.
    // "_ts": (new Date()).toISOString(),  // ⬅ This is causing preflight and it's being cors rejected.
    // "_tz": (new Date()).getTimezoneOffset()/60,
    // "Referrer-Policy": "strict-origin-when-cross-origin",
    // "Referrer-Policy": "no-referrer-when-downgrade",
  },
  withCredentials: true,
  exposedHeaders: ["Set-Cookie", "set-cookie"]
};

// Rewrite .get with a more friendly async/await raw awaited passthrough.
axios._get = axios.get;
axios.get = async (apiUrl, config) => {
  const useConfig = {...axiosConfig, ...config};
  try {
    const axConfig = { url: apiUrl, method: "get", ...useConfig };
    const resp = await axios(axConfig);
    return resp;
  } catch (err) {
    return err;
  }
};

// Rewrite .post with a more friendly async/await raw awaited passthrough.
axios._post = axios.post;
axios.post = (apiUrl, postData, config) => {
  const useConfig = {...axiosConfig, ...config};
  try {
    const axConfig = { url: apiUrl, method: "post", data: postData, ...useConfig };
    const resp = axios(axConfig);
    return resp;
  } catch (err) {
    return err;
  }
};

// Rewrite .put with a more friendly async/await raw awaited passthrough.
// const axiosFormDataConfig = {
//   baseURL: apiDomain,  // This gets ignored if the 'apiUrl' below is a complete URL.
//   timeout: 6000000,
//   headers: {
//     "Accept": "application/json",
//     "Content-Type": "multipart/x-www-form-urlencoded"   // for POST only. This is ignored in GET requests.
//   },
//   withCredentials: true,
//   exposedHeaders: ["Set-Cookie", "set-cookie"]
// };

const axiosFormDataConfig = JSON.parse(JSON.stringify(axiosConfig))
axiosFormDataConfig.timeout = 6000000;

axios.postFile = (apiUrl, formData, onUploadProgressCallback, config) => {
  const useConfig = {...axiosFormDataConfig, ...config};
  if (!!onUploadProgressCallback && typeof(onUploadProgressCallback)==="function") {
    useConfig.onUploadProgress = onUploadProgressCallback;
  }
  try {
    const axConfig = { url: apiUrl, method: "post", data: formData, ...useConfig };
    const resp = axios(axConfig);
    return resp;
  } catch (err) {
    return err;
  }
};

export {
  api,
  axios
};